<template>
  <ion-fab vertical="bottom" horizontal="end" slot="fixed">
    <ion-fab-button>
      <ion-icon :icon="add"></ion-icon>
    </ion-fab-button>
    <ion-fab-list side="top" class="ion-align-items-end" style="right: 0">
      <ion-button
        @click="
          showUploadModal = true;
          uploadModalCaptureMethod = null;
        "
        ><ion-icon :icon="documentsOutline" slot="start" />Dokument
        hochladen</ion-button
      >
      <ion-button
        @click="
          showUploadModal = true;
          uploadModalCaptureMethod = 'environment';
        "
        ><ion-icon :icon="cameraOutline" slot="start" />Foto
        aufnehmen/hochladen</ion-button
      >
      <ion-button v-if="!hideAddDoctor" @click="openAddDoctorModal(true)"
        ><ion-icon
          :icon="require('@lib/assets/icons/calendar-add.svg')"
          slot="start"
        />Nur Termin hinzufügen</ion-button
      >
      <ion-button v-if="!hideAddDoctor" @click="openAddDoctorModal()"
        ><ion-icon :icon="personAddOutline" slot="start" />Arzt/Termin
        hinzufügen</ion-button
      >
    </ion-fab-list>
  </ion-fab>
  <ion-modal
    :is-open="showUploadModal"
    :css-class="['c-autoheight-modal']"
    @didDismiss="showUploadModal = false"
  >
    <ion-page>
      <div class="ion-padding modal-content ion-text-center">
        <modal-close />
        <h6><b>Dokument/Foto hochladen</b></h6>
        <div class="ion-margin-top">
          <file-input
            ref="fileInputElement"
            :captureMethod="uploadModalCaptureMethod"
          />
          <ion-button @click="uploadFile()">Hochladen</ion-button>
        </div>
      </div>
    </ion-page>
  </ion-modal>
</template>

<script>
import {
  IonFab,
  IonFabButton,
  IonFabList,
  modalController,
  IonIcon,
  IonModal,
  IonPage,
  IonButton,
} from "@ionic/vue";
import FileInput from "@/components/FileInput";
import AddDoctorModal from "@/components/AddDoctorModal";
import { ref } from "vue";
import AlertModal from "@/components/AlertModal";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import axios from "@/plugins/axios";
import {
  add,
  documentsOutline,
  cameraOutline,
  personAddOutline,
} from "ionicons/icons";
import ModalClose from "@lib/components/ModalClose";

export default {
  components: {
    IonFab,
    IonFabButton,
    IonFabList,
    FileInput,
    IonIcon,
    IonModal,
    IonPage,
    IonButton,
    ModalClose,
  },
  props: {
    getDoctors: {
      required: false,
    },
    hideAddDoctor: {
      type: Boolean,
      default: false,
    },
    listFiles: {
      required: false,
    },
  },
  setup(props) {
    const router = useRouter();
    const store = useStore();

    const openAddDoctorModal = async (addAppointmentOnly = false) => {
      const modal = await modalController.create({
        component: AddDoctorModal,
        // cssClass: "c-autoheight-modal",
        componentProps: {
          addAppointmentOnly: addAppointmentOnly,
        },
      });
      modal.onDidDismiss().then((result) => {
        if (result?.data?.isEdited && props.getDoctors) {
          props.getDoctors();
        }
      });
      return modal.present();
    };

    const showUploadModal = ref(false);
    const uploadModalCaptureMethod = ref("");
    const fileInputElement = ref();
    const uploadFile = async () => {
      let pondFile = null;
      for (const file of fileInputElement.value.$refs.pond.getFiles()) {
        pondFile = file;
        console.log(file);
      }
      if (!pondFile || (pondFile && pondFile.status !== 2)) {
        const modal = await modalController.create({
          component: AlertModal,
          cssClass: "c-autoheight-modal",
          componentProps: {
            message:
              "Bitte klicken Sie zuvor direkt in das Feld mit dem Pfeil, um eine Auswahl für den Upload zu wählen.",
            buttons: ["Ok"],
          },
        });
        return modal.present();
      } else {
        const formData = new FormData();
        formData.append("File_0", pondFile.file, pondFile.filename);
        store.commit("setShowLoading", true);
        const response = await axios.post(
          "?Mode=General&Function=UploadFile",
          formData
        );
        if (response.data.Status === "Success") {
          fileInputElement.value.$refs.pond.removeFiles();
          showUploadModal.value = false;
          if (props.listFiles) {
            props.listFiles();
          } else {
            router.push({ name: "befunde" });
          }
        }
      }
    };

    return {
      showUploadModal,
      fileInputElement,
      uploadFile,
      uploadModalCaptureMethod,
      openAddDoctorModal,
      add,
      documentsOutline,
      cameraOutline,
      personAddOutline,
    };
  },
};
</script>
